var exports = {
  "iM": "shimmer__e-Iwex",
  "NJ": "shimmerText__MTecuE",
  "qG": "fadeIn__6pyTmq",
  "TZ": "fadeInAnim__NwWpfr",
};

module.exports = exports;
